<template>
  <v-container>
    <h1 class="text-center text-xl font-semibold py-5">Potwierdzenie rejestracji</h1>

    <p>Dziękujemy za rejestrację do udziału w zajęciach chemicznych w ramach projektu "MatFizChemPW - podnoszenie kompetencji matematyczno przyrodniczych oraz ICT u młodzieży szkolnej" (POWR.03.01.00-00-T163/18), współfinansowanego przez Unię Europejską ze środków Europejskiego Funduszu Społecznego w ramach Programu Operacyjnego Wiedza Edukacja Rozwój 2014-2020. Oś III Szkolnictwo wyższe dla gospodarki i rozwoju, Działanie 3.1. Kompetencje w szkolnictwie wyższym.</p>

    <p>Na podany adres email przesłaliśmy komplet dokumentów rekrutacyjnych, który należy wydrukować, podpisać i dostarczyć na pierwsze zajęcia. Dostarczenie tych dokumentów jest warunkiem formalnym udziału w zajęciach.</p>

    <p>Szczegółowe informacje dot. terminów, miejsca realizacji zajęć oraz wszelkich innych istotnych spraw dotyczących projektu/zajęć będą wysyłane drogą mailową bezpośrednio na adres email podany podczas rejestracji na zajęcia.</p>

    <p>W razie pytań lub wątpliwości zapraszamy do kontaktu mailowego pod adresem: matfizchem.klatrat@gmail.com.</p>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>